import { Col, Row } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import PartWrapper from 'mixins/ui/part-wrapper';
import React, { FC, ReactNode, useEffect, useState } from 'react';
import { getLangValue } from '/react4xp/mixins/helpers';
import { getMainBlocks } from '/react4xp/parts/main/main.const';

const Main: FC<any> = (props: any) => {
    const [arr, setArr] = useState([]);

    useEffect(() => {
        setArr(
            getMainBlocks({ ...props, language: getLangValue(props.language) }, props.translations)
        );
    }, []);

    const renderBlockComponents = (index: number): ReactNode[] => {
        return arr
            .filter((x) => props.config[`${x.id}Weight`] === index)
            .map((x) => {
                const isHidden = props.config[`${x.id}IsHidden`];

                return !isHidden && x.node;
            });
    };

    return (
        <PartWrapper
            {...props}
            translations={props.translations}
        >
            <Content>
                <div className="half-back py-4">
                    <div className="container">{renderBlockComponents(5)}</div>
                </div>
                <div className="container">
                    <div className="py-3 main-region">
                        <Row gutter={[16, 16]}>
                            <Col
                                xs={24}
                                xl={16}
                            >
                                {renderBlockComponents(6)}
                            </Col>
                            <Col
                                xs={24}
                                xl={8}
                            >
                                {renderBlockComponents(7)}
                            </Col>
                        </Row>

                        {renderBlockComponents(9)}

                        {renderBlockComponents(8)}

                        {renderBlockComponents(10)}

                        {renderBlockComponents(11)}
                    </div>
                </div>
            </Content>
        </PartWrapper>
    );
};

export default (props) => <Main {...props} />;
